import { render, staticRenderFns } from "./RequestTime.vue?vue&type=template&id=c064bb1a&scoped=true&"
import script from "./RequestTime.vue?vue&type=script&lang=js&"
export * from "./RequestTime.vue?vue&type=script&lang=js&"
import style0 from "./RequestTime.vue?vue&type=style&index=0&id=c064bb1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c064bb1a",
  null
  
)

export default component.exports